var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("套装信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-tip error" }, [
        _vm._v("提示:一次调拨数据最多500条")
      ]),
      _vm._v(" "),
      _c("span", [
        !_vm.taxRateChange
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.showDeviceListDlg()
                  }
                }
              },
              [_vm._v("套装选择")]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-layout" }, [
      !_vm.crossComFlag
        ? _c("div", { staticClass: "input-tip error" }, [
            _vm._v(
              "提示:内部调拨时,套装中资产如果在目标仓库，不会进行调拨并不展示出来。"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "right-toolbar mb5 fr" }, [
        _vm.itemList != null
          ? _c("span", [_vm._v("已选择(" + _vm._s(_vm.itemList.length) + ")")])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.isUpdate
        ? _c(
            "div",
            [
              _c(
                "el-table",
                { attrs: { data: _vm.itemList, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "no",
                      label: "套装系统编号",
                      width: "180",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "套装名称",
                      align: "left",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "套内资产数量",
                      width: "100",
                      align: "right",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.shopDeviceSuitAccList != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      rows.row.shopDeviceSuitAccList.length + 1
                                    )
                                  )
                                ])
                              : _c("span", [_vm._v("1")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "", label: "调入信息", width: "300" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.dstMerchantId != scope.row.retailerId &&
                            scope.row.dstMerchantName != null
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.dstMerchantName))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.dstMerchantId != scope.row.retailerId &&
                            scope.row.dstMerchantName != null &&
                            scope.row.dstBizUnitName != null
                              ? _c("span", [_vm._v("/")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.dstBizUnitName != null
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.dstBizUnitName))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.dstBizUnitName != null &&
                            scope.row.dstComName != null &&
                            scope.row.dstBizUnitName != scope.row.dstComName
                              ? _c("span", [
                                  _vm._v("/" + _vm._s(scope.row.dstComName))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.taxRateChange
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    attrs: { align: "right" },
                                    on: {
                                      click: function($event) {
                                        _vm.selectDstBizUnitName(scope.$index)
                                      }
                                    }
                                  },
                                  [_vm._v("选择机构")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dstWarehouseName",
                      label: "调入仓库",
                      width: "140",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: _vm.taxRateChange,
                                  placeholder: "请选择"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.selectDstWarehouse(scope.$index)
                                  }
                                },
                                model: {
                                  value: scope.row.dstWarehouseId,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "dstWarehouseId", $$v)
                                  },
                                  expression: "scope.row.dstWarehouseId"
                                }
                              },
                              _vm._l(scope.row.dstWareHouseList, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              })
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.normalFlag
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "taxRate",
                          label: "税率(%)",
                          width: "140"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                !_vm.taxRateChange
                                  ? _c("span", [
                                      _vm._v(_vm._s(scope.row.taxRate))
                                    ])
                                  : _vm.taxRateChange
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "请选择税率" },
                                        model: {
                                          value: scope.row.taxRate,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "taxRate", $$v)
                                          },
                                          expression: "scope.row.taxRate"
                                        }
                                      },
                                      _vm._l(_vm.fiscalTaxMarkList, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.rate,
                                          attrs: {
                                            label: item.rate,
                                            value: item.rate
                                          }
                                        })
                                      })
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "devcTitle",
                      label: "主资产名称",
                      align: "left",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "devcTmpNo",
                      label: "主资产系统编号",
                      width: "250",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "devcCatName",
                      label: "主资产分类",
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "devcBrandName",
                      label: "主资产品牌",
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "devcModelSpec",
                      label: "主资产规格",
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "departName",
                      label: "主资产责任部门",
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "principalName",
                      label: "主资产责任人",
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "80",
                      label: "操作",
                      "show-overflow-tooltip": "",
                      fixed: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            !_vm.taxRateChange
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.removeItem(scope.$index)
                                      }
                                    }
                                  },
                                  [_vm._v("移除")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "el-table",
                { attrs: { data: _vm.curDeviceItemList, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "设备名称",
                      align: "left",
                      width: "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "tmpNo", label: "系统编号", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "是否主资产",
                      align: "center",
                      width: "100"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.suitMainFlag
                              ? _c("span", { staticClass: "font-green" }, [
                                  _vm._v("是")
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "", label: "调入信息", width: "300" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.dstMerchantId != scope.row.retailerId &&
                            scope.row.dstMerchantName != null
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.dstMerchantName))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.dstMerchantId != scope.row.retailerId &&
                            scope.row.dstMerchantName != null &&
                            scope.row.dstBizUnitName != null
                              ? _c("span", [_vm._v("/")])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.dstBizUnitName != null
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.dstBizUnitName))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.dstBizUnitName != null &&
                            scope.row.dstComName != null &&
                            scope.row.dstBizUnitName != scope.row.dstComName
                              ? _c("span", [
                                  _vm._v("/" + _vm._s(scope.row.dstComName))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.taxRateChange
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    attrs: { align: "right" },
                                    on: {
                                      click: function($event) {
                                        _vm.selectDstBizUnitName(scope.$index)
                                      }
                                    }
                                  },
                                  [_vm._v("选择机构")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dstWarehouseName",
                      label: "调入仓库",
                      width: "140",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled: _vm.taxRateChange,
                                  placeholder: "请选择"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.selectDstWarehouse(scope.$index)
                                  }
                                },
                                model: {
                                  value: scope.row.dstWarehouseId,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "dstWarehouseId", $$v)
                                  },
                                  expression: "scope.row.dstWarehouseId"
                                }
                              },
                              _vm._l(scope.row.dstWareHouseList, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id }
                                })
                              })
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.normalFlag
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "taxRate",
                          label: "税率(%)",
                          width: "140"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                !_vm.taxRateChange
                                  ? _c("span", [
                                      _vm._v(_vm._s(scope.row.taxRate))
                                    ])
                                  : _vm.taxRateChange
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "请选择税率" },
                                        model: {
                                          value: scope.row.taxRate,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "taxRate", $$v)
                                          },
                                          expression: "scope.row.taxRate"
                                        }
                                      },
                                      _vm._l(_vm.fiscalTaxMarkList, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.rate,
                                          attrs: {
                                            label: item.rate,
                                            value: item.rate
                                          }
                                        })
                                      })
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "suitNo",
                      label: "套装编号",
                      align: "center",
                      width: "200"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "catName",
                      label: "设备分类",
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brandName",
                      label: "设备品牌",
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "modelSpec",
                      label: "设备规格",
                      width: "150",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  !_vm.confirm
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "80",
                          label: "操作",
                          "show-overflow-tooltip": "",
                          fixed: "right"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                !_vm.taxRateChange
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "swb-btn-link",
                                        on: {
                                          click: function($event) {
                                            _vm.removeDeviceItem(scope.$index)
                                          }
                                        }
                                      },
                                      [_vm._v("移除")]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10968ad4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10968ad4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceSuitStockTransItemSelect.vue
// module id = 2557
// module chunks = 0